import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import appwriteService from '../services/AppwriteService';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Add a small delay to ensure the session is properly set
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        const user = await appwriteService.getCurrentUser();
        if (user) {
          navigate('/', { replace: true });
        } else {
          setError('Authentication failed. Please try again.');
          setTimeout(() => navigate('/'), 3000);
        }
      } catch (error) {
        console.error('Error handling OAuth callback:', error);
        setError('An error occurred during authentication. Please try again.');
        setTimeout(() => navigate('/'), 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      gap: 2
    }}>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="h6">Completing sign in...</Typography>
        </>
      )}
    </Box>
  );
} 